import { useMutation } from '@tanstack/react-query'

import { deleteJobSchedule } from '../services/deleteJobSchedule'

export { useDeleteJobSchedule }

const useDeleteJobSchedule = () => {
  return useMutation({
    mutationFn: deleteJobSchedule,
  })
}
